/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEcommJobCardData } from './ecomm-job-card.data';
import { IEcommJobCardProps } from './ecomm-job-card.props.autogenerated';

export interface IEcommJobCardViewProps extends IEcommJobCardProps<IEcommJobCardData> {
    description: React.ReactNode;
}

/**
 *
 * EcommJobCard component
 * @extends {React.PureComponent<IEcommJobCardProps<IEcommJobCardData>>}
 */
class EcommJobCard extends React.PureComponent<IEcommJobCardProps<IEcommJobCardData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const text = config.description && (
            <MsDyn365.RichTextComponent
                text={config.description}
                editProps={{
                    onEdit: this._handleTextChange,
                    requestContext: this.props.context.request
                }}
            />
        );

        const EcommJobCardViewProps = {
            ...this.props,
            description: text
        };

        return this.props.renderView(EcommJobCardViewProps);
    }

    private _handleTextChange = (event: MsDyn365.ContentEditableEvent) => (this.props.config.description = event.target.value);
}

export default EcommJobCard;
